export const defaultCompanyState = {
	companyInfo: {}
};

export default {
	...defaultCompanyState
};
